import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserInfos } from '../../types';

export type State = UserInfos[];

const initialState: State = [];

export const AdminsSlice = createSlice({
  name: 'admins',
  initialState,
  reducers: {
    onSetAdmins: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeleteAdmins: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetAdmins, onDeleteAdmins } = AdminsSlice.actions;

export default AdminsSlice.reducer;
